var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"id":"answer-machine"}},[_c('div',{staticClass:"placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }